import { Injectable } from "@angular/core";
import * as _ from "lodash";
import * as Cookies from "js-cookie";
import { environment } from "../../environments/environment";
import {ActivatedRoute, Router} from "@angular/router";
import {NotificationService} from "../common/services/notification/notification.service";

@Injectable()
export class AuthService {
  constructor(public router: Router, public activatedRoute: ActivatedRoute, private notification: NotificationService) {}
  public getJwtToken(): string {
    return Cookies.get(environment.jwtTokenKey);
  }
  public isAuthenticated(): boolean {
    return !_.isNil(this.getJwtToken());
  }
  public parseQuery(queryString) {
    let query = {};
    let pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
    for (let i = 0; i < pairs.length; i++) {
      let pair = pairs[i].split('=');
      query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
    }
    return query;
  }
  public parseUrl(url) {
    const urlElement = document.createElement('a');
    urlElement.href = url;
    return urlElement;
  }
  public logout() {
    environment.cookieToRemove.forEach(cookie => {
      if (typeof cookie === 'string') {
        if (Cookies.get(cookie)) {
          Cookies.remove(cookie);
        }
      } else if (typeof cookie === 'object') {
        if (cookie.name) {
          if (Cookies.get(cookie.name, _.omit(cookie, ['name']))) {
            Cookies.remove(cookie.name, _.omit(cookie, ['name']));
          }
        }
      }
    });
    this.router.navigate(['login']);
  }

  public redirectUrl() {
    const curUrlParse = this.parseUrl(window.location.href);
    const queryParams = this.parseQuery(curUrlParse.search);
    if (!_.isUndefined(queryParams['redirect'])) {
      let redirectPath = queryParams['redirect'];
      let searchParams = queryParams['search'];
      const urlParse = this.parseUrl(redirectPath);
      if (urlParse && urlParse['protocol']) {
        // if not same means we are redirecting to external url
        if (curUrlParse['hostname'] !== urlParse['hostname']) {
          // make sure we only redirect to same domain
          let splittedHostName = urlParse['hostname'].split(environment.domainName);
          if (splittedHostName.length === 2 && splittedHostName[1] === '') {
            window.location.href = decodeURIComponent(redirectPath) + '?token=' + this.getJwtToken() + '&success=' + this.isAuthenticated();
            return;
          } else {
            redirectPath = '';
            searchParams = '';
          }
        }
      }
      this.router.navigateByUrl(decodeURIComponent(redirectPath), { queryParams: this.parseQuery(decodeURIComponent(searchParams)) });
      return;
    }
    this.router.navigate(['']);
    return;
  }
}
